import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import {
  Delete,
  Visibility,
  Download,
  Store,
  FlagCircle,
  Flag,
  Cancel,
  History,
  Close,
  Inventory,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import CreditModal from "./CreditModal";
import Select from "react-select";
import CustomPagination from "../../Utils/CustomPagination";
import { AddCircle, Edit2, More, Trash } from "iconsax-react";
import { Link } from "react-router-dom";
import { DocumentDownload } from "iconsax-react";


function List(props) {
  let vendorType = "";
  let permissionType = "";

  if (props.currentComp === "distributor") {
    vendorType = "Distributor";
    permissionType = "distributor";
  } else if (props.currentComp === "dealer") {
    vendorType = "Dealer";
    permissionType = "dealer";
  } else if (props.currentComp === "retailer") {
    vendorType = "Retailer";
    permissionType = "retailer";
  } else if (props.currentComp === "key-accounts") {
    vendorType = "Key Accounts";
    permissionType = "key_accounts";
  } else if (props.currentComp === "pro") {
    vendorType = "PRO";
    permissionType = "pro";
  }
  const [distributorsList, setDistributorsList] = useState([]);
  // const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [assignSpOptions, setAssignSpOptions] = useState([]);

  // const [filters, setFilters] = useState({
  //   city: "",
  //   state: "",
  //   district: "",
  //   companyName: "",
  //   assignSp: "",
  // });
  const { filters, setFilters } = props;

  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const handleCloseHistoryModal = () => {
    setShowHistoryModal(false); // Close the modal
    setSelectedRow(null); // Clear the selected row data
  };

  const columns = [
    {
      name: "Company Name",
      selector: (row) => row.companyName,
    },
    {
      name: "Name",
      selector: (row) => row.authorised_person_name,
    },
    {
      name: "Date",
      selector: (row) => moment(row.joining_date).format("DD-MM-yyyy"),
    },
    {
      name: "Status",
      selector: (row) => (row.status === "1" ? "Active" : "In-Active"),
      maxWidth: "100px",
      minWidth: "60px",
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {/* Edit */}
          {utils.hasPermission(
            primaryMenuRes,
            vendorType,
            `${permissionType}.edit`
          ) && (
            <RB.Button
              className="btn-flat"
              title="Edit"
              onClick={() => handelEdit(row)()}
            >
              <Edit2 />
            </RB.Button>
          )}

          {/* Delete */}
          {utils.hasPermission(
            primaryMenuRes,
            vendorType,
            `${permissionType}.delete`
          ) && (
            <RB.Button
              className="btn-flat ms-1 me-1"
              title="Delete"
              onClick={() => showDelete(row)()}
            >
              <Trash />
            </RB.Button>
          )}

          <RB.OverlayTrigger
            trigger="click"
            rootClose
            key="bottom"
            placement="bottom"
            overlay={
              <RB.Popover id={`popover-positioned-bottom`}>
                <RB.Popover.Body className="p-0">
                  <div className="list-group">
                    {/* Godown */}
                    {utils.hasPermission(
                      primaryMenuRes,
                      vendorType,
                      `${permissionType}.godown`
                    ) && (
                      <Link
                        className="list-group-item list-group-item-action"
                        onClick={() => handleGodown(row)()}
                      >
                        <Store /> Godown
                      </Link>
                    )}

                    {/* Target */}
                    {utils.hasPermission(
                      primaryMenuRes,
                      vendorType,
                      `${permissionType}.target`
                    ) && (
                      <Link
                        className="list-group-item list-group-item-action"
                        onClick={() => handleTarget(row)()}
                      >
                        <Flag /> Target
                      </Link>
                    )}

                    {/* View */}
                    <Link
                      className="list-group-item list-group-item-action"
                      onClick={() => handleView(row)()}
                    >
                      <Visibility /> View
                    </Link>

                    {/* Retailer Order */}
                    {["Distributor", "Dealer", "Retailer"].includes(
                      props.heading
                    ) && (
                      <Link
                        className="list-group-item list-group-item-action"
                        onClick={() => handleOrder(row)()}
                      >
                        <Inventory /> Retailer Orders
                      </Link>
                    )}

                    {/* Credit Limit History */}
                    {utils.hasPermission(
                      primaryMenuRes,
                      vendorType,
                      `${permissionType}.credit_limit_history`
                    ) && (
                      <Link
                        className="list-group-item list-group-item-action"
                        onClick={() => handleHistory(row.id)()}
                      >
                        <History /> Credit Limit History
                      </Link>
                    )}

                    {/* Close */}
                    {utils.hasPermission(
                      primaryMenuRes,
                      vendorType,
                      `${permissionType}.close`
                    ) &&
                      row.cancel_status !== "1" && (
                        <Link
                          className="list-group-item list-group-item-action"
                          onClick={() => handleClose(row)()}
                        >
                          <Cancel /> Close
                        </Link>
                      )}
                  </div>
                </RB.Popover.Body>
              </RB.Popover>
            }
          >
            <RB.Button className="btn-flat">
              <More />
            </RB.Button>
          </RB.OverlayTrigger>
        </>
      ),
    },
  ];

  useEffect(() => {
    getAllAssignSp();
  }, []);

  useEffect(() => {
    getQuotationList(filters);
  }, [props.page, userProfile?.id, vendorType]);


  const getQuotationList = (filters) => {
    const bodyFormData = new FormData();

    bodyFormData.append("userId", "");
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", vendorType);

    bodyFormData.append("page", props?.page);
    bodyFormData.append("per_page", countPerPage);
    bodyFormData.append("cancelstatus", "1");

    bodyFormData.append("company_name", filters.companyName ?? "");
    bodyFormData.append("state", filters.state ?? "");
    bodyFormData.append("city", filters.city ?? "");
    bodyFormData.append("district", filters.district ?? "");
    bodyFormData.append(
      "sp",
      Array.isArray(filters.assignSp) ? filters.assignSp.join(",") : ""
    );

    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDistributorsList(res);
        } else {
          setDistributorsList([]);
        }
      })
      .catch((err) => {
        setDistributorsList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleOrder = useCallback((row) => async () => {
    const propdata = {
      mode: "orderListing",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleClose = useCallback((row) => async () => {
    const propdata = {
      mode: "close",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleGodown = useCallback((row) => async () => {
    const propdata = {
      mode: "godown",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleTarget = useCallback((row) => async () => {
    const propdata = {
      mode: "target",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleHistory = useCallback((row) => async () => {
    setSelectedRow(row); // Store the selected row data
    setShowHistoryModal(true); // Show the modal
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/DeleteSalesForm?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getQuotationList(filters);
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleDownload = () => {
  const queryParams = new URLSearchParams({
    company_name: filters.companyName ?? "",
    state: filters.state ?? "",
    district: filters.district ?? "",
    city: filters.city ?? "",
    sp: Array.isArray(filters.assignSp) ? filters.assignSp.join(",") : "",
    vendor_type: vendorType,
    //userId: userProfile?.employeeId ?? "",
    id: "",
    cancelstatus: "1",
  });
console.log("Here is the params",queryParams.toString(),filters.assignSp )
  const downloadUrl = `${
    process.env.REACT_APP_API_URL
  }/sales/downloadExcelReportDistribution?${queryParams.toString()}`;

  window.open(downloadUrl, "_blank");
};


  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

   const handleFilterChange = (e) => {
    props?.setPage(1);
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const getAllAssignSp = () => {
    utils
      .callAPI("get", `/sales/getSalesPersonList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setAssignSpOptions(res);
        } else {
          setAssignSpOptions([]);
        }
      })
      .catch((err) => {
        setAssignSpOptions([]);
      });
  };


  const handleFilterSearchClick = () => {
    getQuotationList(filters);
  };

  const handleFilterResetClick = () => {
    const resetFilters = {
      companyName: "",
      state: "",
      city: "",
      district: "",
      assignSp: "",
    };

    setFilters(resetFilters);
    getQuotationList(resetFilters);
  };

  const handlePageChange = (newPage) => {
    props.setPage(newPage);
  };
  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <div className="floating-btns-holder-artisan">
          {utils.hasPermission(
            primaryMenuRes,
            vendorType,
            `${permissionType}.create`
          ) && (
            <a
              href
              className="btn btn-dark btn-circle me-2"
              variant="dark"
              onClick={handleAddClick}
            >
              <AddCircle />
            </a>
          )}

              <a
                href
                className={`${
                  distributorsList?.result?.length == 0 ? "disabled" : ""
                } btn btn-primary btn-circle `}
                variant="primary"
                onClick={handleDownload}
              >
                <DocumentDownload />
              </a>
        </div>


        <RB.CardHeader>
          <RB.Row>
            <RB.Col md={12} className={"border-bottom mb-2"}>
              <h6>Filters</h6>
            </RB.Col>

            <RB.Col md={4}>
              <RB.Form.Label>City</RB.Form.Label>

              <RB.Form.Control
                type={"text"}
                name={"city"}
                value={filters.city}
                onChange={handleFilterChange}
                style={{ height: "auto" }}
              />
            </RB.Col>

            <RB.Col md={4}>
              <RB.Form.Label>State</RB.Form.Label>
              <RB.Form.Control
                type={"text"}
                name={"state"}
                value={filters.state}
                onChange={handleFilterChange}
                style={{ height: "auto" }}
              />
            </RB.Col>

            <RB.Col md={4}>
              <RB.Form.Label>District</RB.Form.Label>
              <RB.Form.Control
                type={"text"}
                name={"district"}
                value={filters.district}
                onChange={handleFilterChange}
                style={{ height: "auto" }}
              />
            </RB.Col>
            <RB.Col md={4} className="mt-2">
              <RB.Form.Label>Company Name</RB.Form.Label>
              <RB.Form.Control
                type={"text"}
                name={"companyName"}
                value={filters.companyName}
                onChange={handleFilterChange}
                style={{ height: "auto" }}
              />
            </RB.Col>

            <RB.Col md={4} className="mt-2">
              <RB.Form.Label>Assign Sales Person</RB.Form.Label>

              <Select
                isMulti
                options={
                  Array.isArray(assignSpOptions)
                    ? assignSpOptions.map((person) => ({
                        value: String(person.id),
                        label: `${person.firstName} ${person.lastName}`,
                      }))
                    : []
                }
                value={
                  Array.isArray(filters.assignSp)
                    ? assignSpOptions
                        .map((person) => ({
                          value: String(person.id),
                          label: `${person.firstName} ${person.lastName}`,
                        }))
                        .filter((opt) => filters.assignSp.includes(opt.value))
                    : []
                }
                onChange={(selectedOptions) => {
                  props?.setPage(1);

                  const ids = (selectedOptions || []).map((opt) => opt.value);

                  setFilters({ ...filters, assignSp: ids });
                }}
                closeMenuOnSelect={false}
                placeholder="Select Sales Persons..."
                className="bom-productName-select"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderRadius: "30px",
                    borderColor: "#e4e6fc",
                    paddingLeft: "10px",

                    minHeight: "38px",

                    boxShadow: state.isFocused ? "0 0 0 1px #a0a5fc" : "none", // optional focus ring
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    padding: "2px 6px",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    borderRadius: "20px",
                  }),
                }}
              />
            </RB.Col>

            <RB.Col className={"d-flex align-items-end "}>
              <RB.FormGroup>
                <RB.Form.Label>&nbsp;</RB.Form.Label>
                <RB.Button
                  variant="primary"
                  type="button"
                  onClick={handleFilterSearchClick}
                >
                  Submit
                </RB.Button>
                <RB.Button
                  variant="light"
                  type="button"
                  className={"ms-1"}
                  onClick={handleFilterResetClick}
                >
                  Reset
                </RB.Button>
              </RB.FormGroup>
            </RB.Col>
          </RB.Row>
        </RB.CardHeader>

        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            vendorType,
            `${permissionType}.view`
          ) && (
            <DataTable
              columns={columns}
              data={distributorsList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={distributorsList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              paginationComponent={() => (
                <CustomPagination
                  currentPage={props.page}
                  totalRows={distributorsList?.total}
                  rowsPerPage={countPerPage}
                  onPageChange={handlePageChange}
                />
              )}
              striped
              // onChangePage={(page) => props.setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
            />
          )}
        </RB.Card.Body>
      </RB.Card>

      <CreditModal
        show={showHistoryModal}
        handleClose={handleCloseHistoryModal}
        selectedRow={selectedRow}
      />
    </div>
  );
}

export default List;
